export const getCheckoutErrorMessage = (error) => {
  const responseData = error?.response?.data;

  if (responseData?.distance != null && responseData?.maxAllowed != null) {
    const distance = Math.round(Number(responseData.distance));
    const maxAllowed = Math.round(Number(responseData.maxAllowed));

    if (Number.isFinite(distance) && Number.isFinite(maxAllowed)) {
      return `You are ${distance}m away from the office. You must be within ${maxAllowed}m to check out`;
    }
  }

  return responseData?.message || error?.message || 'Check-out failed';
};